module.exports = __webpack_public_path__ + "media/images/run-e2594cdfe9d0b1b9df93dc3136a5b70b.png";